import React from "react";
import { Container, Typography, Button, Grid } from "@material-ui/core";
import useStyles from "./Styled";
import CartItem from "./CartItem/CartItem";
import { Link } from "react-router-dom";

function Cart({
  cart,
  handleEmptyCart,
  handleRemoveFromCart,
  handleUpdateCartQty,
}) {
  const classes = useStyles();

  const EmptyCart = () => {
    return (
      <Typography variant={"subtitle1"}>
        You have no items in your shopping cart,{" "}
        <Link to="/" className={classes.link}>
          start adding some
        </Link>{" "}
        !
      </Typography>
    );
  };

  const FilledCart = () => {
    return (
      <>
        <Grid container spacing={3}>
          {cart.line_items.map(item => (
            <Grid key={item.id} item xs={12} sm={4}>
              <CartItem
                item={item}
                onUpdateCartQty={handleUpdateCartQty}
                onRemoveFromCart={handleRemoveFromCart}
              />
            </Grid>
          ))}
        </Grid>
        <div className={classes.cardDetails}>
          <Typography>
            Subtotal: {cart.subtotal.formatted_with_symbol}
          </Typography>
          <div>
            <Button
              className={classes.emptyButton}
              size="large"
              variant="contained"
              type="button"
              color="secondary"
              onClick={handleEmptyCart}
            >
              Empty Cart
            </Button>
            <Button
              component={Link}
              to={"/checkout"}
              className={classes.checkoutButton}
              size="large"
              variant="contained"
              type="button"
              color="primary"
            >
              Checkout
            </Button>
          </div>
        </div>
      </>
    );
  };
  if (!cart.line_items) return "Loading...";

  return (
    <Container>
      <div className={classes.toolbar} />
      <Typography gutterBottom className={classes.title} variant={"h3"}>
        Your Shopping Cart
      </Typography>
      {!cart.line_items.length ? <EmptyCart /> : <FilledCart />}
    </Container>
  );
}

export default Cart;
